"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WLANObject = void 0;
const tslib_1 = require("tslib");
const RFTransmitterObject_1 = require("./RFTransmitterObject");
const core_1 = require("@openhps/core");
let WLANObject = class WLANObject extends RFTransmitterObject_1.RFTransmitterObject {
};
exports.WLANObject = WLANObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], WLANObject.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", String)
], WLANObject.prototype, "capabilities", void 0);
exports.WLANObject = WLANObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], WLANObject);
//# sourceMappingURL=WLANObject.js.map